








import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({})
export default class Preview extends Vue {
  @Prop({ default: () => [] }) private files!: File[]

  private objectUrl: string | null = null

  private get src() {
    console.log('files', this.files)
    const file = this.files?.[0]
    if (!file) return null
    if (this.objectUrl) URL.revokeObjectURL(this.objectUrl)
    this.objectUrl = URL.createObjectURL(file)
    console.log('objectUrl', this.objectUrl)
    return this.objectUrl
  }

  beforeDestroy() {
    if (this.objectUrl) URL.revokeObjectURL(this.objectUrl)
  }
}
